// extracted by mini-css-extract-plugin
export default {"IconCell":"IconCell_IconCell__NxI2b","img":"IconCell_img__m4dz9"};